<template>
    <div style="text-align:center;padding: 10vh 0">
        <i class="fa fa-spin fa-spinner" /> Preparing</div>
</template>

<script>
export default {
    mounted() {
        this.$router.push('/onboarding');
    }
}
</script>